/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1Emails, createTKT1Email, updateTKT1Email, deleteTKT1Email } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS, generateTOTP } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt, FaUpload, FaImage, FaStickyNote, FaKey } from 'react-icons/fa';
import IframeModal from '../components/IframeModal/IframeModal';
import ImageUploadModal from '../components/ImageUploadModal/ImageUploadModal';

class TKT1Email extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 100,
    sortBy: 'MID',
    sortOrder: 1,
    search: '',
    type: '',
    status: ''
  }

  initShowColumns = {
    MID: true,
    email: true,
    name: true,
    country: true,
    password: true,
    recovery_email: true,
    code_2fa: true,
    phone: true,
    address: true,
    avatar: true,
    type: true,
    status: true,
    registered_date: true,
    etsy_register_date: true,
    price: true,
    purchase_date: true,
    ref_etsy_info_pack_mid: true,
    note: true
  }

  initColumnWidths = {
    stt: 60,
    MID: 120,
    avatar: 80,
    email: 200,
    name: 150,
    country: 100,
    password: 150,
    recovery_email: 180,
    code_2fa: 120,
    phone: 130,
    address: 200,
    type: 100,
    status: 120,
    registered_date: 150,
    etsy_register_date: 150,
    price: 120,
    purchase_date: 130,
    ref_etsy_info_pack_mid: 180,
    note: 200,
    actions: 100
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      columnWidths: this.initColumnWidths,
      loading: false,
      showConfigModal: false,
      showCreateModal: false,
      showEditModal: false,
      showViewModal: false,
      showIframeModal: false,
      showImageUploadModal: false,
      showNoteModal: false,
      showDeleteModal: false,
      showOtpModal: false,
      otpEmail: null,
      otpResult: null,
      otpError: '',
      iframeUrl: '',
      iframeTitle: '',
      selectedEmail: null,
      selectedNoteData: null,
      isEditMode: false,
      uploadingImages: false,
      uploadedImages: [],
      isResizing: false,
      resizingColumn: null,
      resizeStartX: null,
      resizeStartWidth: null,
      createFormData: {
        email: '',
        name: '',
        country: '',
        password: '',
        recovery_email: '',
        code_2fa: '',
        phone: '',
        address: '',
        avatar: '',
        type: 'EMAIL1',
        status: 'ACTIVE',
        registered_date: '',
        etsy_register_date: '',
        price: 0,
        purchase_date: '',
        ref_etsy_info_pack_mid: '',
        note: ''
      },
      editFormData: {
        email: '',
        name: '',
        country: '',
        password: '',
        recovery_email: '',
        code_2fa: '',
        phone: '',
        address: '',
        avatar: '',
        type: 'EMAIL1',
        status: 'ACTIVE',
        registered_date: '',
        etsy_register_date: '',
        price: 0,
        purchase_date: '',
        ref_etsy_info_pack_mid: '',
        note: ''
      }
    };
  }

  componentDidMount() {
    const routeType = this.getRouteType();
    const titleMap = {
      'all': 'TKT1 Email - All',
      'EMAIL1': 'TKT1 Email - Email 1',
      'EMAIL2': 'TKT1 Email - Email 2',
      'TOOL': 'TKT1 Email - Tool',
      'EMAIL_SYSTEM': 'TKT1 Email - Email System'
    };
    document.title = titleMap[routeType] || 'TKT1 Email';
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    // Check if URL has any query parameters
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    if (hasUrlParams) {
      // URL has query parameters - override localStorage
      const queryObject = queryString.parse(queryStringFromUrl);
      
      // Parse numeric values
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      // Load showColumns separately from view config
      const viewConfig = JSON.parse(localStorage.getItem('TKT1Email_ViewConfig'));
      const columnWidths = JSON.parse(localStorage.getItem('TKT1Email_ColumnWidths'));
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      // Override type based on route if not 'all'
      if (routeType !== 'all') {
        restoredQuery.type = routeType;
      }

      this.setState({
        query: restoredQuery,
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        },
        columnWidths: {
          ...this.initColumnWidths,
          ...(columnWidths || {})
        }
      }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1Emails(apiQuery);
      })
    } else {
      // No URL params - use localStorage
      var query = JSON.parse(localStorage.getItem('tkt1_email_query'));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1Email_ViewConfig'));
      var columnWidths = JSON.parse(localStorage.getItem('TKT1Email_ColumnWidths'));
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        // Override type based on route if not 'all'
        if (routeType !== 'all') {
          restored.type = routeType;
        }

        this.setState({
          query: restored,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          columnWidths: {
            ...this.initColumnWidths,
            ...(columnWidths || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1Emails(apiQuery);
        })
      } else {
        const initialQuery = { ...this.initQuery };
        
        // Override type based on route if not 'all'
        if (routeType !== 'all') {
          initialQuery.type = routeType;
        }

        this.setState({
          query: initialQuery,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          },
          columnWidths: {
            ...this.initColumnWidths,
            ...(columnWidths || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1Emails(apiQuery);
        })
      }
    }
    
    // Add mouse event listeners for column resizing
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  }

  componentWillUnmount() {
    // Remove mouse event listeners
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);

    // Stop OTP auto refresh
    this.stopOtpTimer();
  }

  // Get route type from URL path
  getRouteType = () => {
    const path = window.location.pathname;
    // Check for TKT1 Asset routes
    if (path.includes('/email/email1')) return 'EMAIL1';
    if (path.includes('/email/email2')) return 'EMAIL2';
    if (path.includes('/email/tool')) return 'TOOL';
    if (path.includes('/email/email-system')) return 'EMAIL_SYSTEM';
    if (path.includes('/email/all')) return 'all';
    
    // Check for TKT1 Media routes
    if (path.includes('/tkt1-media/resource/email-tool')) return 'TOOL';
    
    return 'all'; // default
  }

  // Check if we should show type filter
  shouldShowTypeFilter = () => {
    const routeType = this.getRouteType();
    return routeType === 'all';
  }

  loadData = () => {
    const apiQuery = this.prepareApiQuery(this.state.query);
    this.props.getTKT1Emails(apiQuery);
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleTypeChange = (e) => {
    const newQuery = { ...this.state.query, type: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_email_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1Emails(apiQuery);
  }


  handleStatusChange = (e) => {
    const newQuery = { ...this.state.query, status: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_email_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1Emails(apiQuery);
  }

  handleSelectSort = (e) => {
    const newQuery = { ...this.state.query, sortBy: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_email_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1Emails(apiQuery);
  }

  handleSelectSortOrder = (e) => {
    const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value) };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_email_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1Emails(apiQuery);
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newShowColumns = {
        ...prevState.showColumns,
        [columnKey]: !prevState.showColumns[columnKey]
      };
      
      // Save view config to localStorage
      localStorage.setItem('TKT1Email_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  // Column resizing handlers
  resetColumnWidths = () => {
    this.setState({ columnWidths: this.initColumnWidths });
    localStorage.removeItem('TKT1Email_ColumnWidths');
  }

  handleMouseDown = (e, columnKey) => {
    e.preventDefault();
    e.stopPropagation();
    
    this.setState({
      isResizing: true,
      resizingColumn: columnKey,
      resizeStartX: e.clientX,
      resizeStartWidth: this.state.columnWidths[columnKey]
    });
    
    document.body.classList.add('table-resizing');
  }

  handleMouseMove = (e) => {
    if (!this.state.isResizing || !this.state.resizingColumn) return;
    
    e.preventDefault();
    const deltaX = e.clientX - this.state.resizeStartX;
    const newWidth = Math.max(50, this.state.resizeStartWidth + deltaX);
    const resizingColumn = this.state.resizingColumn;
    
    this.setState(prevState => ({
      columnWidths: {
        ...prevState.columnWidths,
        [resizingColumn]: newWidth
      }
    }));
  }

  handleMouseUp = () => {
    if (this.state.isResizing) {
      this.setState({
        isResizing: false,
        resizingColumn: null,
        resizeStartX: null,
        resizeStartWidth: null
      });
      
      document.body.classList.remove('table-resizing');
      
      // Save column widths to localStorage
      localStorage.setItem('TKT1Email_ColumnWidths', JSON.stringify(this.state.columnWidths));
    }
  }

  // Map status to Vietnamese
  mapStatus = (status) => {
    if (!status) return '-';
    switch (status.toUpperCase()) {
      case 'ACTIVE':
        return 'Hoạt động';
      case 'INACTIVE':
        return 'Không hoạt động';
      case 'SUSPENDED':
        return 'Tạm dừng';
      case 'EXPIRED':
        return 'Hết hạn';
      case 'CANCELLED':
        return 'Hủy';
      default:
        return status;
    }
  }

  // Map type to Vietnamese
  mapType = (type) => {
    if (!type) return '-';
    switch (type.toUpperCase()) {
      case 'EMAIL1':
        return 'Email 1';
      case 'EMAIL2':
        return 'Email 2';
      case 'TOOL':
        return 'Tool';
      case 'EMAIL_SYSTEM':
        return 'Email System';
      default:
        return type;
    }
  }

  // Copy text to clipboard
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  // Modal handlers
  handleViewClick = (email) => {
    this.setState({
      showViewModal: true,
      selectedEmail: email,
      isEditMode: false
    });
  }

  handleEditClick = (email) => {
    this.setState({
      showEditModal: true,
      selectedEmail: email,
      isEditMode: true,
      editFormData: {
        email: email.email || '',
        name: email.name || '',
        country: email.country || '',
        password: email.password || '',
        recovery_email: email.recovery_email || '',
        code_2fa: email.code_2fa || '',
        phone: email.phone || '',
        address: email.address || '',
        avatar: email.avatar || '',
        type: email.type || 'EMAIL1',
        status: email.status || 'ACTIVE',
        registered_date: email.registered_date ? 
          new Date(email.registered_date).toISOString().split('T')[0] : '',
        etsy_register_date: email.etsy_register_date ? 
          new Date(email.etsy_register_date).toISOString().split('T')[0] : '',
        price: email.price || 0,
        purchase_date: email.purchase_date ? 
          new Date(email.purchase_date).toISOString().split('T')[0] : '',
        ref_etsy_info_pack_mid: email.ref_etsy_info_pack_mid || '',
        note: email.note || ''
      }
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedEmail: null,
      isEditMode: false
    });
  }

  handleCloseCreateModal = () => {
    this.setState({
      showCreateModal: false,
      createFormData: {
        email: '',
        name: '',
        country: '',
        password: '',
        recovery_email: '',
        code_2fa: '',
        phone: '',
        address: '',
        avatar: '',
        type: 'EMAIL1',
        status: 'ACTIVE',
        registered_date: '',
        etsy_register_date: '',
        price: 0,
        purchase_date: '',
        ref_etsy_info_pack_mid: '',
        note: ''
      }
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedEmail: null,
      isEditMode: false,
      editFormData: {
        email: '',
        name: '',
        country: '',
        password: '',
        recovery_email: '',
        code_2fa: '',
        phone: '',
        address: '',
        avatar: '',
        type: 'EMAIL1',
        status: 'ACTIVE',
        registered_date: '',
        etsy_register_date: '',
        price: 0,
        purchase_date: '',
        ref_etsy_info_pack_mid: '',
        note: ''
      }
    });
  }

  handleEtsyInfoPackClick = (refEtsyInfoPackMid) => {
    if (refEtsyInfoPackMid) {
      this.setState({
        showIframeModal: true,
        iframeUrl: `/admin/tkt1-etsy/etsy-info-pack-detail/${refEtsyInfoPackMid}`,
        iframeTitle: `Etsy Info Pack Detail - ${refEtsyInfoPackMid}`
      });
    }
  }

  handleCloseIframeModal = () => {
    this.setState({
      showIframeModal: false,
      iframeUrl: '',
      iframeTitle: ''
    });
  }

  handleOpenImageUploadModal = () => {
    this.setState({ showImageUploadModal: true });
  }

  handleCloseImageUploadModal = () => {
    this.setState({ 
      showImageUploadModal: false,
      uploadedImages: [] // Clear uploaded images to prevent caching
    });
  }

  handleImagesUploaded = (newImages) => {
    if (newImages && newImages.length > 0) {
      // For avatar, we only take the first image
      const avatarUrl = newImages[0].link;
      this.setState(prevState => ({
        createFormData: {
          ...prevState.createFormData,
          avatar: avatarUrl
        },
        editFormData: {
          ...prevState.editFormData,
          avatar: avatarUrl
        },
        uploadedImages: [...prevState.uploadedImages, ...newImages]
      }));
    }
  }

  // OTP (2FA) modal handlers
  otpTimer = null;

  refreshOtp = () => {
    const { otpEmail } = this.state;
    if (!otpEmail) return;

    try {
      const otpResult = generateTOTP(otpEmail.code_2fa);
      this.setState({ otpResult, otpError: '' });
    } catch (error) {
      this.setState({ otpResult: null, otpError: error.message || 'Không tính được mã OTP' });
    }
  }

  startOtpTimer = () => {
    this.stopOtpTimer();
    this.otpTimer = setInterval(this.refreshOtp, 1000);
  }

  stopOtpTimer = () => {
    if (this.otpTimer) {
      clearInterval(this.otpTimer);
      this.otpTimer = null;
    }
  }

  handleOtpClick = (email) => {
    this.setState({
      showOtpModal: true,
      otpEmail: email,
      otpResult: null,
      otpError: ''
    }, () => {
      this.refreshOtp();
      this.startOtpTimer();
    });
  }

  handleCloseOtpModal = () => {
    this.stopOtpTimer();
    this.setState({
      showOtpModal: false,
      otpEmail: null,
      otpResult: null,
      otpError: ''
    });
  }

  // Note modal handlers
  handleNoteClick = (email) => {
    this.setState({
      showNoteModal: true,
      selectedNoteData: {
        MID: email.MID,
        email: email.email,
        name: email.name,
        note: email.note
      }
    });
  }

  handleCloseNoteModal = () => {
    this.setState({
      showNoteModal: false,
      selectedNoteData: null
    });
  }

  // Helper function to truncate note text
  truncateNote = (note, maxLength = 50) => {
    if (!note || note.length <= maxLength) {
      return note;
    }
    return note.substring(0, maxLength) + '...';
  }

  handleCreateInputChange = (field, value) => {
    this.setState({
      createFormData: {
        ...this.state.createFormData,
        [field]: value
      }
    });
  }

  handleEditInputChange = (field, value) => {
    this.setState({
      editFormData: {
        ...this.state.editFormData,
        [field]: value
      }
    });
  }

  handleCreateEmail = async () => {
    const { createFormData } = this.state;
    
    // Validation
    if (!createFormData.email) {
      alert('Vui lòng nhập email');
      return;
    }

    try {
      // Call create action
      await this.props.createTKT1Email(createFormData);
      
      // Close modal
      this.handleCloseCreateModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1Emails(apiQuery);
      
      alert('Tạo email mới thành công!');
    } catch (error) {
      console.error('Error creating email:', error);
      alert('Lỗi khi tạo email mới. Vui lòng thử lại.');
    }
  }

  handleSaveEdit = async () => {
    const { selectedEmail, editFormData } = this.state;
    
    if (!selectedEmail || !selectedEmail._id) {
      alert('Không tìm thấy thông tin Email để cập nhật');
      return;
    }

    try {
      // Call update action
      await this.props.updateTKT1Email(selectedEmail._id, editFormData);
      
      // Close modal
      this.handleCloseEditModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1Emails(apiQuery);
      
      alert('Cập nhật thông tin Email thành công!');
    } catch (error) {
      console.error('Error updating email:', error);
      alert('Lỗi khi cập nhật thông tin Email. Vui lòng thử lại.');
    }
  }

  // Delete email handlers
  handleDeleteClick = (email) => {
    this.setState({
      showDeleteModal: true,
      selectedEmail: email
    });
  }

  handleCloseDeleteModal = () => {
    this.setState({
      showDeleteModal: false,
      selectedEmail: null
    });
  }

  handleConfirmDelete = async () => {
    const { selectedEmail } = this.state;
    
    if (!selectedEmail || !selectedEmail._id) {
      alert('Không tìm thấy thông tin Email để xóa');
      return;
    }

    try {
      // Call delete action
      await this.props.deleteTKT1Email(selectedEmail._id);
      
      // Close modal
      this.handleCloseDeleteModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1Emails(apiQuery);
      
      alert('Xóa Email thành công!');
    } catch (error) {
      console.error('Error deleting email:', error);
      alert('Lỗi khi xóa Email. Vui lòng thử lại.');
    }
  }

  // Helper function to prepare API query
  prepareApiQuery = (query) => {
    const { showColumns, search, type, status, country, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    // Add type filter if selected
    if (type && type.trim()) {
      apiQuery.type = type;
    }
    
    // Add status filter if selected
    if (status && status.trim()) {
      apiQuery.status = status;
    }
    
    // Add country filter if selected
    if (country && country.trim()) {
      apiQuery.country = country;
    }
    
    return apiQuery;
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    // Save to localStorage
    localStorage.setItem('tkt1_email_query', JSON.stringify(trimmedQuery));
    
    this.setState({
      query: { ...this.state.query, itemsPerPage, currentPage: 1 }
    }, () => {
      this.updateUrl(trimmedQuery);
      this.props.getTKT1Emails(apiQuery);
    })
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  handleSearch = () => {
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.updateUrl(trimmedQuery);
    this.props.getTKT1Emails(apiQuery);
    localStorage.setItem('tkt1_email_query', JSON.stringify(trimmedQuery));
  }

  updateUrl = (query) => {
    const { history } = this.props;
    // Remove showColumns from URL query - it's only for client display
    const { showColumns, ...urlQuery } = query;
    const queryStr = queryString.stringify(urlQuery);

    // Determine pathname based on route type and current path
    const routeType = this.getRouteType();
    const currentPath = window.location.pathname;
    
    // Check if we're in TKT1 Media routes
    if (currentPath.includes('/tkt1-media/resource/email-tool')) {
      const pathname = '/admin/tkt1-media/resource/email-tool';
      history.push({
        pathname: pathname,
        search: queryStr,
      });
      return;
    }
    
    // TKT1 Asset routes
    const pathMap = {
      'all': '/admin/tkt1-asset/email/all',
      'EMAIL1': '/admin/tkt1-asset/email/email1',
      'EMAIL2': '/admin/tkt1-asset/email/email2',
      'TOOL': '/admin/tkt1-asset/email/tool',
      'EMAIL_SYSTEM': '/admin/tkt1-asset/email/email-system'
    };
    const pathname = pathMap[routeType] || '/admin/tkt1-asset/email/all';

    history.push({
      pathname: pathname,
      search: queryStr,
    });
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ emails: [] }, () => {
        this.updateUrl(trimmedQuery);
        this.props.getTKT1Emails(apiQuery);
        localStorage.setItem('tkt1_email_query', JSON.stringify(trimmedQuery));
      })
    })
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="3">
          <InputGroup className="mb-3">
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo email, tên, MID..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        {this.shouldShowTypeFilter() && (
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Loại</InputGroup.Text>
            <Form.Select
              value={this.state.query.type}
              onChange={this.handleTypeChange}
            >
              <option value="">Tất cả</option>
              <option value="EMAIL1">Email 1</option>
              <option value="EMAIL2">Email 2</option>
              <option value="TOOL">Tool</option>
              <option value="EMAIL_SYSTEM">Email System</option>
            </Form.Select>
          </InputGroup>
        </Col>
        )}
        <Col md={this.shouldShowTypeFilter() ? "2" : "2"}>
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.status}
              onChange={this.handleStatusChange}
            >
              <option value="">Tất cả</option>
              <option value="ACTIVE">Hoạt động</option>
              <option value="INACTIVE">Không hoạt động</option>
              <option value="SUSPENDED">Tạm dừng</option>
              <option value="DELETED">Đã xóa</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md={this.shouldShowTypeFilter() ? "2" : "3"}>
          <InputGroup>
            <InputGroup.Text>Sắp xếp theo</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="MID">MID</option>
              <option value="email">Email</option>
              <option value="name">Tên</option>
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
              <option value="registered_date">Ngày đăng ký</option>
              <option value="etsy_register_date">Ngày đăng ký Etsy</option>
              <option value="purchase_date">Ngày mua</option>
              <option value="price">Giá</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md={this.shouldShowTypeFilter() ? "2" : "3"}>
          <InputGroup>
            <InputGroup.Text>Thứ tự</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortOrder}
              onChange={this.handleSelectSortOrder}
            >
              <option value="-1">Giảm dần</option>
              <option value="1">Tăng dần</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="1" className="d-flex align-items-center justify-content-end">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderEmailTable = () => {
    const { emails } = this.props;
    const { showColumns, columnWidths } = this.state;
    
    // Ensure emails is an array and filter out any null/undefined items
    const safeEmails = Array.isArray(emails) ? emails.filter(email => email != null && typeof email === 'object') : [];
    
    // Early return if no data to prevent any rendering issues
    if (!safeEmails || safeEmails.length === 0) {
      return (
        <Table striped bordered hover style={{ tableLayout: 'auto' }}>
          <thead>
            <tr>
              <th style={{ width: `${columnWidths.stt}px`, position: 'relative' }}>
                STT
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'stt')}
                />
              </th>
              {showColumns.MID && <th style={{ width: `${columnWidths.MID}px`, position: 'relative' }}>
                MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'MID')}
                />
              </th>}
              {showColumns.avatar && <th style={{ width: `${columnWidths.avatar}px`, position: 'relative' }}>
                Avatar
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'avatar')}
                />
              </th>}
              {showColumns.email && <th style={{ width: `${columnWidths.email}px`, position: 'relative' }}>
                Email
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'email')}
                />
              </th>}
              {showColumns.name && <th style={{ width: `${columnWidths.name}px`, position: 'relative' }}>
                Tên
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'name')}
                />
              </th>}
              {showColumns.country && <th style={{ width: `${columnWidths.country}px`, position: 'relative' }}>
                Quốc gia
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'country')}
                />
              </th>}
              {showColumns.password && <th style={{ width: `${columnWidths.password}px`, position: 'relative' }}>
                Mật khẩu
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'password')}
                />
              </th>}
              {showColumns.recovery_email && <th style={{ width: `${columnWidths.recovery_email}px`, position: 'relative' }}>
                Email khôi phục
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'recovery_email')}
                />
              </th>}
              {showColumns.code_2fa && <th style={{ width: `${columnWidths.code_2fa}px`, position: 'relative' }}>
                Mã 2FA
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'code_2fa')}
                />
              </th>}
              {showColumns.phone && <th style={{ width: `${columnWidths.phone}px`, position: 'relative' }}>
                Số điện thoại
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'phone')}
                />
              </th>}
              {showColumns.address && <th style={{ width: `${columnWidths.address}px`, position: 'relative' }}>
                Địa chỉ
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'address')}
                />
              </th>}
              {showColumns.type && <th style={{ width: `${columnWidths.type}px`, position: 'relative' }}>
                Loại
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'type')}
                />
              </th>}
              {showColumns.status && <th style={{ width: `${columnWidths.status}px`, position: 'relative' }}>
                Trạng thái
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'status')}
                />
              </th>}
              {showColumns.registered_date && <th style={{ width: `${columnWidths.registered_date}px`, position: 'relative' }}>
                Ngày đăng ký
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'registered_date')}
                />
              </th>}
              {showColumns.etsy_register_date && <th style={{ width: `${columnWidths.etsy_register_date}px`, position: 'relative' }}>
                Ngày đăng ký Etsy
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'etsy_register_date')}
                />
              </th>}
              {showColumns.price && <th style={{ width: `${columnWidths.price}px`, position: 'relative' }}>
                Giá
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'price')}
                />
              </th>}
              {showColumns.purchase_date && <th style={{ width: `${columnWidths.purchase_date}px`, position: 'relative' }}>
                Ngày mua
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'purchase_date')}
                />
              </th>}
              {showColumns.ref_etsy_info_pack_mid && <th style={{ width: `${columnWidths.ref_etsy_info_pack_mid}px`, position: 'relative' }}>
                Etsy Info Pack MID
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'ref_etsy_info_pack_mid')}
                />
              </th>}
              {showColumns.note && <th style={{ width: `${columnWidths.note}px`, position: 'relative' }}>
                Ghi chú
                <div 
                  className="resize-handle"
                  onMouseDown={(e) => this.handleMouseDown(e, 'note')}
                />
              </th>}
              <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover style={{ tableLayout: 'auto' }}>
        <thead>
          <tr>
            <th style={{ width: `${columnWidths.stt}px`, position: 'relative' }}>
              STT
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'stt')}
              />
            </th>
            {showColumns.MID && <th style={{ width: `${columnWidths.MID}px`, position: 'relative' }}>
              MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'MID')}
              />
            </th>}
            {showColumns.avatar && <th style={{ width: `${columnWidths.avatar}px`, position: 'relative' }}>
              Avatar
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'avatar')}
              />
            </th>}
            {showColumns.email && <th style={{ width: `${columnWidths.email}px`, position: 'relative' }}>
              Email
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'email')}
              />
            </th>}
            {showColumns.name && <th style={{ width: `${columnWidths.name}px`, position: 'relative' }}>
              Tên
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'name')}
              />
            </th>}
            {showColumns.country && <th style={{ width: `${columnWidths.country}px`, position: 'relative' }}>
              Quốc gia
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'country')}
              />
            </th>}
            {showColumns.password && <th style={{ width: `${columnWidths.password}px`, position: 'relative' }}>
              Mật khẩu
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'password')}
              />
            </th>}
            {showColumns.recovery_email && <th style={{ width: `${columnWidths.recovery_email}px`, position: 'relative' }}>
              Email khôi phục
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'recovery_email')}
              />
            </th>}
            {showColumns.code_2fa && <th style={{ width: `${columnWidths.code_2fa}px`, position: 'relative' }}>
              Mã 2FA
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'code_2fa')}
              />
            </th>}
            {showColumns.phone && <th style={{ width: `${columnWidths.phone}px`, position: 'relative' }}>
              Số điện thoại
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'phone')}
              />
            </th>}
            {showColumns.address && <th style={{ width: `${columnWidths.address}px`, position: 'relative' }}>
              Địa chỉ
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'address')}
              />
            </th>}
            {showColumns.type && <th style={{ width: `${columnWidths.type}px`, position: 'relative' }}>
              Loại
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'type')}
              />
            </th>}
            {showColumns.status && <th style={{ width: `${columnWidths.status}px`, position: 'relative' }}>
              Trạng thái
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'status')}
              />
            </th>}
            {showColumns.registered_date && <th style={{ width: `${columnWidths.registered_date}px`, position: 'relative' }}>
              Ngày đăng ký
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'registered_date')}
              />
            </th>}
            {showColumns.etsy_register_date && <th style={{ width: `${columnWidths.etsy_register_date}px`, position: 'relative' }}>
              Ngày đăng ký Etsy
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'etsy_register_date')}
              />
            </th>}
            {showColumns.price && <th style={{ width: `${columnWidths.price}px`, position: 'relative' }}>
              Giá
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'price')}
              />
            </th>}
            {showColumns.purchase_date && <th style={{ width: `${columnWidths.purchase_date}px`, position: 'relative' }}>
              Ngày mua
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'purchase_date')}
              />
            </th>}
            {showColumns.ref_etsy_info_pack_mid && <th style={{ width: `${columnWidths.ref_etsy_info_pack_mid}px`, position: 'relative' }}>
              Etsy Info Pack MID
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'ref_etsy_info_pack_mid')}
              />
            </th>}
            {showColumns.note && <th style={{ width: `${columnWidths.note}px`, position: 'relative' }}>
              Ghi chú
              <div 
                className="resize-handle"
                onMouseDown={(e) => this.handleMouseDown(e, 'note')}
              />
            </th>}
            <th style={{ width: `${columnWidths.actions}px` }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeEmails.map((email, index) => {
            if (!email || typeof email !== 'object') return null;
              
              return (
                <tr key={email._id || index}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {showColumns.MID && (
                    <td>
                      {email.MID ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{email.MID}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(email.MID)}
                            title="Copy MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.avatar && (
                    <td>
                      {email.avatar ? (
                        <img 
                          src={email.avatar} 
                          alt="Avatar"
                          style={{ 
                            width: '40px', 
                            height: '40px', 
                            objectFit: 'cover',
                            borderRadius: '50%',
                            border: '2px solid #dee2e6'
                          }}
                        />
                      ) : (
                        <div 
                          style={{ 
                            width: '40px', 
                            height: '40px', 
                            backgroundColor: '#f8f9fa',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '2px solid #dee2e6'
                          }}
                        >
                          <FaImage size={16} color="#6c757d" />
                        </div>
                      )}
                    </td>
                  )}
                  {showColumns.email && (
                    <td>
                      {email.email ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{email.email}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(email.email)}
                            title="Copy Email"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.name && (
                    <td>
                      {email.name || '-'}
                    </td>
                  )}
                  {showColumns.country && (
                    <td>
                      {email.country || '-'}
                    </td>
                  )}
                  {showColumns.password && (
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <span>{email.password || '-'}</span>
                        {email.password && (
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(email.password)}
                            title="Copy Password"
                          />
                        )}
                      </div>
                    </td>
                  )}
                  {showColumns.recovery_email && (
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <span>{email.recovery_email || '-'}</span>
                        {email.recovery_email && (
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(email.recovery_email)}
                            title="Copy Recovery Email"
                          />
                        )}
                      </div>
                    </td>
                  )}
                  {showColumns.code_2fa && (
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <span>{email.code_2fa || '-'}</span>
                        {email.code_2fa && (
                          <>
                            <FaCopy
                              size={12}
                              style={{ cursor: 'pointer', color: '#6c757d' }}
                              onClick={() => this.copyToClipboard(email.code_2fa)}
                              title="Copy 2FA Code"
                            />
                            <FaKey
                              size={12}
                              style={{ cursor: 'pointer', color: '#0d6efd', flexShrink: 0 }}
                              onClick={() => this.handleOtpClick(email)}
                              title="Xem mã OTP"
                            />
                          </>
                        )}
                      </div>
                    </td>
                  )}
                  {showColumns.phone && (
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <span>{email.phone || '-'}</span>
                        {email.phone && (
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(email.phone)}
                            title="Copy Phone"
                          />
                        )}
                      </div>
                    </td>
                  )}
                  {showColumns.address && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} title={email.address}>
                        {email.address || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.type && (
                    <td>
                      {email.type ? (
                        <Badge 
                          bg={
                            email.type === 'EMAIL1' ? 'primary' :
                            email.type === 'EMAIL2' ? 'success' :
                            email.type === 'TOOL' ? 'warning' :
                            email.type === 'EMAIL_SYSTEM' ? 'info' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapType(email.type)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.status && (
                    <td>
                      {email.status ? (
                        <Badge 
                          bg={
                            email.status === 'ACTIVE' ? 'success' :
                            email.status === 'INACTIVE' ? 'warning' :
                            email.status === 'SUSPENDED' ? 'info' :
                            email.status === 'DELETED' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(email.status)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.registered_date && (
                    <td>
                      {email.registered_date ? 
                        new Date(email.registered_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </td>
                  )}
                  {showColumns.etsy_register_date && (
                    <td>
                      {email.etsy_register_date ? 
                        new Date(email.etsy_register_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </td>
                  )}
                  {showColumns.price && (
                    <td>
                      {email.price ? (
                        <span className="text-success fw-bold">
                          {email.price.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.purchase_date && (
                    <td>
                      {email.purchase_date ? 
                        new Date(email.purchase_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </td>
                  )}
                  {showColumns.ref_etsy_info_pack_mid && (
                    <td>
                      {email.ref_etsy_info_pack_mid ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge 
                            bg="info" 
                            style={{ 
                              fontSize: '0.9em', 
                              padding: '6px 10px',
                              cursor: 'pointer'
                            }}
                            onClick={() => this.handleEtsyInfoPackClick(email.ref_etsy_info_pack_mid)}
                            title="Click để xem chi tiết Etsy Info Pack"
                          >
                            {email.ref_etsy_info_pack_mid}
                          </Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(email.ref_etsy_info_pack_mid)}
                            title="Copy Etsy Info Pack MID"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.note && (
                    <td>
                      {email.note ? (
                        <div className="d-flex align-items-center gap-2">
                          <span 
                            style={{ 
                              whiteSpace: 'nowrap',
                              cursor: email.note.length > 100 ? 'pointer' : 'default'
                            }}
                            title={email.note}
                          >
                            {this.truncateNote(email.note)}
                          </span>
                          {email.note.length > 100 && (
                            <FaStickyNote 
                              size={12} 
                              style={{ 
                                cursor: 'pointer', 
                                color: '#6c757d',
                                flexShrink: 0
                              }}
                              onClick={() => this.handleNoteClick(email)}
                              title="Xem đầy đủ ghi chú"
                            />
                          )}
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaEye 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Xem thông tin"
                        onClick={() => this.handleViewClick(email)}
                      />
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(email)}
                      />
                      <FaTrash 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#dc3545'
                        }}
                        title="Xóa email"
                        onClick={() => this.handleDeleteClick(email)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    const { columnWidths } = this.state;
    
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                {(() => {
                  const routeType = this.getRouteType();
                  const titleMap = {
                    'all': 'TKT1 Email - Danh sách tất cả',
                    'EMAIL1': 'TKT1 Email - Email 1',
                    'EMAIL2': 'TKT1 Email - Email 2',
                    'TOOL': 'TKT1 Email - Tool',
                    'EMAIL_SYSTEM': 'TKT1 Email - Email System'
                  };
                  return titleMap[routeType] || 'TKT1 Email';
                })()}
              </h2>
            </Col>
            <Col className="text-end">
              <Button 
                variant="success" 
                onClick={() => this.setState({ showCreateModal: true })}
                className="me-2"
              >
                <i className="fas fa-plus me-1"></i>
                Thêm Email mới
              </Button>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <Button 
                  variant="secondary" 
                  size="sm"
                  className="me-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                </Button>
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={200}>200</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="sticky-table">
              {this.renderEmailTable()}
              </div>
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Hiển thị cột</h6>
                {Object.entries(this.state.showColumns || {}).map(([column, isVisible]) => {
                  const columnLabels = {
                    MID: 'MID',
                    email: 'Email',
                    name: 'Tên',
                    country: 'Quốc gia',
                    password: 'Mật khẩu',
                    recovery_email: 'Email khôi phục',
                    code_2fa: 'Mã 2FA',
                    phone: 'Số điện thoại',
                    address: 'Địa chỉ',
                    avatar: 'Avatar',
                    type: 'Loại',
                    status: 'Trạng thái',
                    registered_date: 'Ngày đăng ký',
                    etsy_register_date: 'Ngày đăng ký Etsy',
                    price: 'Giá',
                    purchase_date: 'Ngày mua',
                    ref_etsy_info_pack_mid: 'Etsy Info Pack MID',
                    note: 'Ghi chú'
                  };
                  
                  return (
                    <Form.Check
                      key={column}
                      type="switch"
                      id={`column-${column}`}
                      label={columnLabels[column] || column}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                  );
                })}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <Modal show={this.state.showViewModal} onHide={this.handleCloseViewModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thông tin Email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedEmail && (
              <div>
                {/* Basic Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin cơ bản</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Email:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedEmail.email}
                      </Badge>
                      {this.state.selectedEmail.email && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedEmail.email)}
                          title="Copy Email"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Tên:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmail.name || '-'}</span>
                      {this.state.selectedEmail.name && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedEmail.name)}
                          title="Copy Name"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Quốc gia:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmail.country || '-'}</span>
                      {this.state.selectedEmail.country && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedEmail.country)}
                          title="Copy Country"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Loại:</strong> 
                    <div className="mt-1">
                      {this.state.selectedEmail.type ? (
                        <Badge 
                          bg={
                            this.state.selectedEmail.type === 'EMAIL1' ? 'primary' :
                            this.state.selectedEmail.type === 'EMAIL2' ? 'success' :
                            this.state.selectedEmail.type === 'TOOL' ? 'warning' :
                            this.state.selectedEmail.type === 'EMAIL_SYSTEM' ? 'info' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapType(this.state.selectedEmail.type)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Security Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin bảo mật</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Mật khẩu:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <Badge bg="warning" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedEmail.password || '-'}
                      </Badge>
                      {this.state.selectedEmail.password && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedEmail.password)}
                          title="Copy Password"
                        />
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Email khôi phục:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmail.recovery_email || '-'}</span>
                      {this.state.selectedEmail.recovery_email && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedEmail.recovery_email)}
                          title="Copy Recovery Email"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Mã 2FA:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmail.code_2fa || '-'}</span>
                      {this.state.selectedEmail.code_2fa && (
                        <>
                          <FaCopy
                            size={14}
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(this.state.selectedEmail.code_2fa)}
                            title="Copy 2FA Code"
                          />
                          <FaKey
                            size={14}
                            style={{ cursor: 'pointer', color: '#0d6efd' }}
                            onClick={() => this.handleOtpClick(this.state.selectedEmail)}
                            title="Xem mã OTP"
                          />
                        </>
                      )}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Số điện thoại:</strong> 
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span>{this.state.selectedEmail.phone || '-'}</span>
                      {this.state.selectedEmail.phone && (
                        <FaCopy 
                          size={14} 
                          style={{ cursor: 'pointer', color: '#6c757d' }}
                          onClick={() => this.copyToClipboard(this.state.selectedEmail.phone)}
                          title="Copy Phone"
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                
                {/* Financial Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin tài chính</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Giá:</strong> 
                    <div className="mt-1">
                      {this.state.selectedEmail.price ? (
                        <span className="text-success fw-bold">
                          {this.state.selectedEmail.price.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày mua:</strong> 
                    <div className="mt-1">
                      {this.state.selectedEmail.purchase_date ? 
                        new Date(this.state.selectedEmail.purchase_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
                
                {/* Date Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin ngày tháng</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày đăng ký:</strong> 
                    <div className="mt-1">
                      {this.state.selectedEmail.registered_date ? 
                        new Date(this.state.selectedEmail.registered_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày đăng ký Etsy:</strong> 
                    <div className="mt-1">
                      {this.state.selectedEmail.etsy_register_date ? 
                        new Date(this.state.selectedEmail.etsy_register_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày mua:</strong> 
                    <div className="mt-1">
                      {this.state.selectedEmail.purchase_date ? 
                        new Date(this.state.selectedEmail.purchase_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Etsy Info Pack MID:</strong> 
                    <div className="mt-1">
                      {this.state.selectedEmail.ref_etsy_info_pack_mid ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge 
                            bg="info" 
                            style={{ 
                              fontSize: '0.9em', 
                              padding: '6px 10px',
                              cursor: 'pointer'
                            }}
                            onClick={() => this.handleEtsyInfoPackClick(this.state.selectedEmail.ref_etsy_info_pack_mid)}
                            title="Click để xem chi tiết Etsy Info Pack"
                          >
                            {this.state.selectedEmail.ref_etsy_info_pack_mid}
                          </Badge>
                          <FaCopy 
                            size={14} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(this.state.selectedEmail.ref_etsy_info_pack_mid)}
                            title="Copy Etsy Info Pack MID"
                          />
                        </div>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Status Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Trạng thái</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      {this.state.selectedEmail.status ? (
                        <Badge 
                          bg={
                            this.state.selectedEmail.status === 'ACTIVE' ? 'success' :
                            this.state.selectedEmail.status === 'INACTIVE' ? 'warning' :
                            this.state.selectedEmail.status === 'SUSPENDED' ? 'info' :
                            this.state.selectedEmail.status === 'DELETED' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(this.state.selectedEmail.status)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Avatar Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Avatar</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12" className="text-center">
                    {this.state.selectedEmail.avatar ? (
                      <img 
                        src={this.state.selectedEmail.avatar} 
                        alt="Avatar"
                        style={{ 
                          width: '150px', 
                          height: '150px', 
                          objectFit: 'cover',
                          borderRadius: '50%',
                          border: '3px solid #dee2e6'
                        }}
                      />
                    ) : (
                      <div 
                        style={{ 
                          width: '150px', 
                          height: '150px', 
                          backgroundColor: '#f8f9fa',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          border: '3px solid #dee2e6',
                          margin: '0 auto'
                        }}
                      >
                        <FaImage size={50} color="#6c757d" />
                      </div>
                    )}
                  </Col>
                </Row>
                
                {/* Additional Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin bổ sung</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Địa chỉ:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedEmail.address || '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedEmail.note || '-'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseViewModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Create Modal */}
        <Modal show={this.state.showCreateModal} onHide={this.handleCloseCreateModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thêm Email mới</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.email}
                      onChange={(e) => this.handleCreateInputChange('email', e.target.value)}
                      placeholder="Nhập địa chỉ email"
                      autoComplete="off"
                      autoCorrect="off"
                      autoCapitalize="off"
                      spellCheck="false"
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tên</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.name}
                      onChange={(e) => this.handleCreateInputChange('name', e.target.value)}
                      placeholder="Nhập tên"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Quốc gia</Form.Label>
                    <Form.Select
                      value={this.state.createFormData.country}
                      onChange={(e) => this.handleCreateInputChange('country', e.target.value)}
                    >
                      <option value="">Chọn quốc gia</option>
                      <option value="VN">Việt Nam</option>
                      <option value="US">Mỹ</option>
                      <option value="UK">Anh</option>
                      <option value="CA">Canada</option>
                      <option value="AU">Úc</option>
                      <option value="OTHER">Khác</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Loại</Form.Label>
                    <Form.Select
                      value={this.state.createFormData.type}
                      onChange={(e) => this.handleCreateInputChange('type', e.target.value)}
                    >
                      <option value="EMAIL1">Email 1</option>
                      <option value="EMAIL2">Email 2</option>
                      <option value="TOOL">Tool</option>
                      <option value="EMAIL_SYSTEM">Email System</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Mật khẩu</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.password}
                      onChange={(e) => this.handleCreateInputChange('password', e.target.value)}
                      placeholder="Nhập mật khẩu"
                      autoComplete="off"
                      autoCorrect="off"
                      autoCapitalize="off"
                      spellCheck="false"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Email khôi phục</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.recovery_email}
                      onChange={(e) => this.handleCreateInputChange('recovery_email', e.target.value)}
                      placeholder="Nhập email khôi phục"
                      autoComplete="off"
                      autoCorrect="off"
                      autoCapitalize="off"
                      spellCheck="false"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Mã 2FA</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.code_2fa}
                      onChange={(e) => this.handleCreateInputChange('code_2fa', e.target.value)}
                      placeholder="Nhập mã 2FA"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Số điện thoại</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.phone}
                      onChange={(e) => this.handleCreateInputChange('phone', e.target.value)}
                      placeholder="Nhập số điện thoại"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Giá (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.createFormData.price}
                      onChange={(e) => this.handleCreateInputChange('price', parseFloat(e.target.value) || 0)}
                      placeholder="Nhập giá"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Etsy Info Pack MID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.createFormData.ref_etsy_info_pack_mid}
                      onChange={(e) => this.handleCreateInputChange('ref_etsy_info_pack_mid', e.target.value)}
                      placeholder="Nhập Etsy Info Pack MID"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày đăng ký</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.createFormData.registered_date}
                      onChange={(e) => this.handleCreateInputChange('registered_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày đăng ký Etsy</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.createFormData.etsy_register_date}
                      onChange={(e) => this.handleCreateInputChange('etsy_register_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày mua</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.createFormData.purchase_date}
                      onChange={(e) => this.handleCreateInputChange('purchase_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.createFormData.status}
                      onChange={(e) => this.handleCreateInputChange('status', e.target.value)}
                    >
                      <option value="ACTIVE">Hoạt động</option>
                      <option value="INACTIVE">Không hoạt động</option>
                      <option value="SUSPENDED">Tạm dừng</option>
                      <option value="DELETED">Đã xóa</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Địa chỉ</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={this.state.createFormData.address}
                      onChange={(e) => this.handleCreateInputChange('address', e.target.value)}
                      placeholder="Nhập địa chỉ"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.createFormData.note}
                      onChange={(e) => this.handleCreateInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              {/* Avatar Upload Section */}
              <Row className="mb-4">
                <Col>
                  <h6 className="text-primary">Avatar</h6>
                  <hr />
                  <div className="border rounded p-3">
                    {this.state.createFormData.avatar ? (
                      <div className="text-center">
                        <img 
                          src={this.state.createFormData.avatar} 
                          alt="Avatar"
                          style={{ 
                            width: '120px', 
                            height: '120px', 
                            objectFit: 'cover',
                            borderRadius: '50%',
                            border: '3px solid #dee2e6',
                            marginBottom: '15px'
                          }}
                        />
                        <div className="d-flex gap-2 justify-content-center">
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={this.handleOpenImageUploadModal}
                          >
                            <FaUpload size={12} className="me-1" />
                            Thay đổi Avatar
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => this.handleCreateInputChange('avatar', '')}
                          >
                            <FaTimes size={12} className="me-1" />
                            Xóa Avatar
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center text-muted py-4">
                        <div 
                          style={{ 
                            width: '120px', 
                            height: '120px', 
                            backgroundColor: '#f8f9fa',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '3px dashed #dee2e6',
                            margin: '0 auto 15px'
                          }}
                        >
                          <FaImage size={40} color="#6c757d" />
                        </div>
                        <p className="mb-3">Chưa có avatar</p>
                        <Button
                          variant="primary"
                          onClick={this.handleOpenImageUploadModal}
                        >
                          <FaUpload size={14} className="me-2" />
                          Upload Avatar
                        </Button>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseCreateModal}>
              Hủy
            </Button>
            <Button variant="success" onClick={this.handleCreateEmail}>
              <i className="fas fa-plus me-1"></i>
              Tạo Email mới
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Chỉnh sửa Email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.email}
                      onChange={(e) => this.handleEditInputChange('email', e.target.value)}
                      placeholder="Nhập địa chỉ email"
                      autoComplete="off"
                      autoCorrect="off"
                      autoCapitalize="off"
                      spellCheck="false"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tên</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.name}
                      onChange={(e) => this.handleEditInputChange('name', e.target.value)}
                      placeholder="Nhập tên"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Quốc gia</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.country}
                      onChange={(e) => this.handleEditInputChange('country', e.target.value)}
                    >
                      <option value="">Chọn quốc gia</option>
                      <option value="VN">Việt Nam</option>
                      <option value="US">Mỹ</option>
                      <option value="UK">Anh</option>
                      <option value="CA">Canada</option>
                      <option value="AU">Úc</option>
                      <option value="OTHER">Khác</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Loại</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.type}
                      onChange={(e) => this.handleEditInputChange('type', e.target.value)}
                    >
                      <option value="EMAIL1">Email 1</option>
                      <option value="EMAIL2">Email 2</option>
                      <option value="TOOL">Tool</option>
                      <option value="EMAIL_SYSTEM">Email System</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Mật khẩu</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.password}
                      onChange={(e) => this.handleEditInputChange('password', e.target.value)}
                      placeholder="Nhập mật khẩu"
                      autoComplete="off"
                      autoCorrect="off"
                      autoCapitalize="off"
                      spellCheck="false"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Email khôi phục</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.recovery_email}
                      onChange={(e) => this.handleEditInputChange('recovery_email', e.target.value)}
                      placeholder="Nhập email khôi phục"
                      autoComplete="off"
                      autoCorrect="off"
                      autoCapitalize="off"
                      spellCheck="false"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Mã 2FA</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.code_2fa}
                      onChange={(e) => this.handleEditInputChange('code_2fa', e.target.value)}
                      placeholder="Nhập mã 2FA"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Số điện thoại</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.phone}
                      onChange={(e) => this.handleEditInputChange('phone', e.target.value)}
                      placeholder="Nhập số điện thoại"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Giá (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.price}
                      onChange={(e) => this.handleEditInputChange('price', parseFloat(e.target.value) || 0)}
                      placeholder="Nhập giá"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày mua</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.editFormData.purchase_date}
                      onChange={(e) => this.handleEditInputChange('purchase_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày đăng ký</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.editFormData.registered_date}
                      onChange={(e) => this.handleEditInputChange('registered_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày đăng ký Etsy</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.editFormData.etsy_register_date}
                      onChange={(e) => this.handleEditInputChange('etsy_register_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày mua</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.editFormData.purchase_date}
                      onChange={(e) => this.handleEditInputChange('purchase_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Etsy Info Pack MID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_etsy_info_pack_mid}
                      onChange={(e) => this.handleEditInputChange('ref_etsy_info_pack_mid', e.target.value)}
                      placeholder="Nhập Etsy Info Pack MID"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                    >
                      <option value="ACTIVE">Hoạt động</option>
                      <option value="INACTIVE">Không hoạt động</option>
                      <option value="SUSPENDED">Tạm dừng</option>
                      <option value="DELETED">Đã xóa</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Địa chỉ</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={this.state.editFormData.address}
                      onChange={(e) => this.handleEditInputChange('address', e.target.value)}
                      placeholder="Nhập địa chỉ"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleEditInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              {/* Avatar Upload Section */}
              <Row className="mb-4">
                <Col>
                  <h6 className="text-primary">Avatar</h6>
                  <hr />
                  <div className="border rounded p-3">
                    {this.state.editFormData.avatar ? (
                      <div className="text-center">
                        <img 
                          src={this.state.editFormData.avatar} 
                          alt="Avatar"
                          style={{ 
                            width: '120px', 
                            height: '120px', 
                            objectFit: 'cover',
                            borderRadius: '50%',
                            border: '3px solid #dee2e6',
                            marginBottom: '15px'
                          }}
                        />
                        <div className="d-flex gap-2 justify-content-center">
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={this.handleOpenImageUploadModal}
                          >
                            <FaUpload size={12} className="me-1" />
                            Thay đổi Avatar
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => this.handleEditInputChange('avatar', '')}
                          >
                            <FaTimes size={12} className="me-1" />
                            Xóa Avatar
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center text-muted py-4">
                        <div 
                          style={{ 
                            width: '120px', 
                            height: '120px', 
                            backgroundColor: '#f8f9fa',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '3px dashed #dee2e6',
                            margin: '0 auto 15px'
                          }}
                        >
                          <FaImage size={40} color="#6c757d" />
                        </div>
                        <p className="mb-3">Chưa có avatar</p>
                        <Button
                          variant="primary"
                          onClick={this.handleOpenImageUploadModal}
                        >
                          <FaUpload size={14} className="me-2" />
                          Upload Avatar
                        </Button>
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveEdit}>
              Lưu thay đổi
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Iframe Modal */}
        <IframeModal
          show={this.state.showIframeModal}
          onHide={this.handleCloseIframeModal}
          url={this.state.iframeUrl}
          title={this.state.iframeTitle}
          showSidebar={false}
        />

        {/* Image Upload Modal */}
        <ImageUploadModal
          show={this.state.showImageUploadModal}
          onHide={this.handleCloseImageUploadModal}
          onImagesUploaded={this.handleImagesUploaded}
          title="Upload Avatar"
          maxImages={1}
          existingImages={this.state.uploadedImages}
        />

        {/* OTP Modal */}
        <Modal show={this.state.showOtpModal} onHide={this.handleCloseOtpModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Mã OTP (2FA)</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.otpEmail && (
              <div>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Email:</strong>
                    <div className="mt-1">
                      <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.otpEmail.email}
                      </Badge>
                    </div>
                  </Col>
                </Row>

                {this.state.otpError ? (
                  <div className="alert alert-danger" role="alert">
                    {this.state.otpError}
                  </div>
                ) : this.state.otpResult && (
                  <>
                    <div className="text-center p-3 bg-light rounded" style={{ border: '1px solid #dee2e6' }}>
                      <div
                        className="text-primary fw-bold"
                        style={{ fontSize: '2.5rem', letterSpacing: '6px', fontFamily: 'monospace' }}
                      >
                        {this.state.otpResult.code}
                      </div>
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="mt-2"
                        onClick={() => this.copyToClipboard(this.state.otpResult.code)}
                      >
                        <FaCopy size={12} className="me-1" />
                        Copy mã OTP
                      </Button>
                    </div>

                    <div className="mt-3">
                      <div className="d-flex justify-content-between">
                        <small className="text-muted">Mã mới sau</small>
                        <small className={this.state.otpResult.remaining <= 5 ? 'text-danger fw-bold' : 'text-muted'}>
                          {this.state.otpResult.remaining}s
                        </small>
                      </div>
                      <div className="progress mt-1" style={{ height: '6px' }}>
                        <div
                          className={`progress-bar ${this.state.otpResult.remaining <= 5 ? 'bg-danger' : 'bg-success'}`}
                          role="progressbar"
                          style={{ width: `${(this.state.otpResult.remaining / this.state.otpResult.period) * 100}%` }}
                        />
                      </div>
                    </div>
                  </>
                )}

                <Row className="mt-3">
                  <Col md="12">
                    <strong>Secret 2FA:</strong>
                    <div className="mt-1 d-flex align-items-center gap-2">
                      <span style={{ wordBreak: 'break-all' }}>{this.state.otpEmail.code_2fa}</span>
                      <FaCopy
                        size={12}
                        style={{ cursor: 'pointer', color: '#6c757d', flexShrink: 0 }}
                        onClick={() => this.copyToClipboard(this.state.otpEmail.code_2fa)}
                        title="Copy secret 2FA"
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseOtpModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Note Modal */}
        <Modal show={this.state.showNoteModal} onHide={this.handleCloseNoteModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Ghi chú chi tiết</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedNoteData && (
              <div>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>MID:</strong> 
                    <div className="mt-1">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedNoteData.MID}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Email:</strong> 
                    <div className="mt-1">
                      <Badge bg="primary" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedNoteData.email}
                      </Badge>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Tên:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNoteData.name || '-'}
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-2 p-3 bg-light rounded" style={{ 
                      whiteSpace: 'pre-wrap',
                      maxHeight: '400px',
                      overflowY: 'auto',
                      border: '1px solid #dee2e6'
                    }}>
                      {this.state.selectedNoteData.note || 'Không có ghi chú'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseNoteModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal show={this.state.showDeleteModal} onHide={this.handleCloseDeleteModal}>
          <Modal.Header closeButton>
            <Modal.Title>Xác nhận xóa Email</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedEmail && (
              <div>
                <p>Bạn có chắc chắn muốn xóa email này không?</p>
                <div className="alert alert-warning" role="alert">
                  <strong>Email:</strong> {this.state.selectedEmail.email}<br/>
                  <strong>MID:</strong> {this.state.selectedEmail.MID || 'N/A'}<br/>
                  <strong>Tên:</strong> {this.state.selectedEmail.name || 'N/A'}
                </div>
                <p className="text-danger">
                  <strong>Cảnh báo:</strong> Hành động này không thể hoàn tác!
                </p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseDeleteModal}>
              Hủy
            </Button>
            <Button variant="danger" onClick={this.handleConfirmDelete}>
              <FaTrash size={14} className="me-1" />
              Xóa Email
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    emails: state.tkt1EmailReducer.emails,
    totalCount: state.tkt1EmailReducer.totalCount
  };
};

export default connect(mapStateToProps, { getTKT1Emails, createTKT1Email, updateTKT1Email, deleteTKT1Email })(TKT1Email);
